export default { SET_FE_VERIFIED: 'SET_FE_VERIFIED' };
